import React, { ElementType, FC, ForwardedRef, forwardRef } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';

export interface FooterIconButtonProps extends IconButtonProps<ElementType> {}

/**
 * Section for the main links
 */
export const FooterIconButton: FC<FooterIconButtonProps> = forwardRef(({ children, ...rest }, ref) => {
  return (
    <IconButton
      size="medium"
      color="white"
      ref={ref as ForwardedRef<HTMLButtonElement>}
      data-testid="FooterIconButton"
      {...rest}
    >
      {children}
    </IconButton>
  );
});
